import routes from './routes'
import store from './store'

export default {
    name: 'm-configs',
    store: store,
    routes: routes
}